import gql from 'graphql-tag';

export const QUERY_PRODUCTS_BY_IDS = gql`query($ids: [Int]) { 
  products(where: {include: $ids, orderby: {field: IN}}) {
    nodes {
      databaseId
      slug
      name 
      reviewCount
      type
      link
      image {
        sourceUrl(size: THUMBNAIL)
      }
      ... on SimpleProduct {
        price
      }
      ... on VariableProduct {
        id
        name
        price
      }
      reviews {
        averageRating
      }
      acfProducts {
        productType
        hireId
        hirePriceWeek
      }
    }
  }
}
`;
export default QUERY_PRODUCTS_BY_IDS;